import React, { useState } from 'react'
import { Grid } from '@material-ui/core'
import AsterTabs from 'asterX-UI/Tabs/AsterTabs'
import AsterTab from 'asterX-UI/Tabs/AsterTab'
import { a11yProps } from 'asterX-UI/Tabs/TabPanel'

import { ApplicationInfo } from '../ApplicationInfo/ApplicationInfo'
import { ApplicationDocuments } from '../ApplicationDocuments/ApplicationDocuments'

import { useStyles } from './application-tabs.styles'

export const ApplicationTabs = ({ application }) => {
  const classes = useStyles()
  const [activeTab, setActiveTab] = useState(0)

  const tabs = [
    { label: 'Информация о заявлении', component: <ApplicationInfo application={application} /> },
    { label: 'Документы', component: <ApplicationDocuments files={application?.files || []} /> }
  ]

  return (
    <Grid container>
      <Grid item container className={classes.tabsContainer}>
        <AsterTabs className={classes.tabs} value={activeTab} onChange={(e, value) => setActiveTab(value)}>
          {tabs.map((t, i) => (
            <AsterTab key={`app-tab-${i}`} label={t.label} value={i} {...a11yProps(i)} />
          ))}
        </AsterTabs>
      </Grid>
      <Grid item container>
        {tabs[activeTab]?.component}
      </Grid>
    </Grid>
  )
}
